import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Inventario",
    items: [
      { label: "Inventario",            icon: "fas fa-warehouse", href: "/ListadoInventarios",           perm: "inventarios" },
      { label: "Disponible", icon: "fas fa-calculator", href: "/ReporteDisponible", perm: "menu_inventarios" },
      { label: "Ajuste de Inventario", icon: "fas fa-sliders-h", href: "/AjusteInventarios", perm: "menu_inventarios" },
      { label: "Inventario Costos",     icon: "fas fa-warehouse", href: "/ListadoInventariosCostos",     perm: "inventarios" },
    ],
  },
  {
    title: "Traspasos",
    items: [
      { label: "Traspasos Salida",  icon: "fas fa-sign-out-alt", href: "/ListadoTraspasosSalida",  perm: "menu_traspasos_salida"  },
      { label: "Traspasos Entrada", icon: "fas fa-sign-in-alt",  href: "/ListadoTraspasosEntrada", perm: "menu_traspasos_entrada" },
    ],
  },
  {
    title: "Seguimiento",
    items: [
      { label: "Almacenes",                icon: "fas fa-warehouse",      href: "/Areas",               perm: "inventarios" },
      { label: "Seguimiento",              icon: "fas fa-search",         href: "/ListadoSeguimiento",  perm: "inventarios" },
    ],
  },
];

function BotonesInventarios() {
  return (
    <MenuGrid
      title="Inventarios"
      subtitle="Stock, traspasos y seguimiento"
      icon="fas fa-warehouse"
      accent={{ color: "#0ea5e9", bg: "#f0f9ff" }}
      gate="menu_inventarios"
      sections={SECTIONS}
    />
  );
}

export default BotonesInventarios;
